@include component-spacing-and-grid;

:host(.defaultMargin) {
    margin-top: 16px;
}

.grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

@media (width <= 1024px) and (width >= 768px) {
    .grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (width >= 1024px) {
    .grid {
        grid-template-columns: repeat(4, 1fr);
    }
}
